import axiosService from './axios.service';
import ResponseService from './response.service';

const createPaymentRequest = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'investments/create_payment_request',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const trackPaymentStatus = async (_formData) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'investments/track_payment_status',
      isAuthorized: true,
      formData: _formData,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const getMolliePaymentDetails = async (order_id) => {
  try {
    let axiosData = {
      method: 'get',
      url: 'investments/get_mollie_payment_details',
      isAuthorized: true,
      params: order_id,
    };

    const response = await axiosService.hit(axiosData);

    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const cancelBankTransaction = async (order_id) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'investments/cancel_bank_transaction',
      isAuthorized: true,
      params: order_id,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const updateTransactionStatus = async (order_id) => {
  try {
    let axiosData = {
      method: 'post',
      url: 'investments/update_transaction_status',
      isAuthorized: true,
      formData: { order_id },
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};
const getMolliePaymentList = async () => {
  try {
    let axiosData = {
      method: 'get',
      url: 'investments/get_mollie_payment_list',
      isAuthorized: true,
    };

    const response = await axiosService.hit(axiosData);
    return response.data;
  } catch (error) {
    return ResponseService.buildFailure(error.message);
  }
};

const UserInvestmentService = {
  createPaymentRequest,
  trackPaymentStatus,
  getMolliePaymentDetails,
  cancelBankTransaction,
  updateTransactionStatus,
  getMolliePaymentList,
};

export default UserInvestmentService;
